import { Upload } from 'antd';
import styled from 'styled-components';

export const StyledUploader = styled(Upload.Dragger)`
  display: grid;
  margin-bottom: 10px;
  min-height: 200px;
`;
